module.exports = __webpack_public_path__ + "static/media/Picture66.1.970a540c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture66.1.png
// module id = 1532
// module chunks = 0